<template>
  <div>
    <div class="m-header">
      <img :src="pwcLogo" style="height: 0.6rem" alt="普华永道 You Plus" @click="$_goHome">
      <div class="header-right">
        <span v-if="lang === 'en'" class="lang" @click="changeLang('en')">中文</span>
        <span v-else class="lang" @click="changeLang('zh')">EN</span>
        <van-icon name="wap-nav" size="0.5rem" @click="$_openMenu" />
      </div>
    </div>
    <van-popup v-model="showMenu" closeable position="right" close-icon-position="top-right" :style="{ width:'70%', height:'100%' }">
      <van-cell :title="$t('mobile.home')" :class="$route.path === '/m' ? 'active': ''" @click.stop="$_goHome" />
      <van-cell-group v-for="(item, index) in menu" :key="index" :title="item.title">
        <van-cell v-for="(path, ind) in item.paths" :key="ind" :class="$route.path === path.path ? 'active': ''" :title="path.title" @click.stop="$_selectMenu(path)" />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import pwcLogo from '@/assets/logo-white.png'
import store from '@/store'
import Actions from '@/constants/action'
import { common } from './common/mixin.js'

export default {
  name: 'NavBar',
  mixins: [common],
  data() {
    return {
      pwcLogo,
      showMenu: false,
      pageLoading: false,
      menu: [
        {
          title: this.$t('mobile.careerDevelopment'),
          paths: [
            {
              title: this.$t('mobile.careerInsights'),
              path: '/m/article/qzgh'
            },
            {
              title: this.$t('mobile.latestEvents'),
              path: '/m/article/event'
            },
            {
              title: this.$t('mobile.careerOpportunities'),
              path: '/m/article/sxhjyjh'
            },
            {
              title: this.$t('mobile.careerProgrammes'),
              path: '/m/careerProgrammes'
            }
          ]
        },
        {
          title: this.$t('mobile.capabilityDiagnosis'),
          paths: [
            {
              title: this.$t('mobile.capabilityDiagnosis'),
              path: '/m/diagnosis'
            }
          ]
        },
        {
          title: this.$t('mobile.peerSharing'),
          paths: [
            {
              title: this.$t('mobile.peerStories'),
              path: '/m/article/xygs'
            },
            {
              title: this.$t('mobile.highlightMoments'),
              path: 'https://mp.weixin.qq.com/s/8nFRDkvQk5JvfkkSwf-A_w'
            },
            {
              title: this.$t('mobile.campusAmbassador'),
              path: '/m/article/xyds'
            },
            {
              title: this.$t('mobile.callForLetters'),
              path: 'https://mp.weixin.qq.com/s/EZUOva0mI1KO93bwMSyQWg'
            },
            {
              title: this.$t('mobile.internshipChallenge'),
              path: '/m/article/tzy'
            }
          ]
        }
      ],
      preview: this.$route.query.preview || null
    }
  },
  watch: {
    showMenu: {
      handler(val) {
        const app = document.getElementById('app')
        if (val) {
          app.style = 'position:fixed;height:100%;width:100%;'
        } else {
          app.style = ''
        }
      }
    }
  },
  methods: {
    changeLang(lang) {
      if (!this.preview) {
        if (lang === 'en') {
        // this.pageLoading = true
          store.dispatch(Actions.SET_LANGUAGE, 'zh')
          this.$i18n.locale = 'zh'
          window.location.reload()
        } else {
        // this.pageLoading = true
          store.dispatch(Actions.SET_LANGUAGE, 'en')
          this.$i18n.locale = 'en'
          window.location.reload()
        }
      }
    },
    $_openMenu() {
      if (!this.preview) {
        this.showMenu = true
      }
    },
    $_selectMenu(item) {
      this.showMenu = false
      if (item.path !== this.$route.fullPath) {
        console.log(item.path)
        if (item.path.substr(0, 7).toLowerCase() === 'http://' || item.path.substr(0, 8).toLowerCase() === 'https://') {
          window.open(item.path, '_self')
        } else {
          this.$router.push({ path: item.path })
        }
      }
    },
    $_goHome() {
      if (!this.preview) {
        this.$router.push({ path: '/m' })
      }
    }
  }
}
</script>
